import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppConfigService } from './data/app-config.service';
import { catchError, tap } from 'rxjs/operators';
import { of } from 'rxjs';
import { Router } from '@angular/router';

const urlAPI = 'https://apilaravel.ml/api/auth/';

const httpOption = {
    headers: new HttpHeaders().set('Content-Type', 'application/json' )
};

@Injectable({providedIn: 'root'})
export class LoginService {

    private urlLogin: string;
    
    constructor(private http: HttpClient, private settings: AppConfigService,private _router:Router) {
        this.urlLogin = this.settings.getUrlApi() + 'auth/';
    }

    getTokenLogin = (userData) => {
        return this.http.post(this.urlLogin+ 'login', JSON.stringify(userData), httpOption);              
    }

    async login(credentials) {
        let response = false;
        console.table("Credentials : ", credentials);
        if( credentials.email    === 'ego@go.com' && 
            credentials.password === 'uno') {
            response = true;
        }
        return {
            typeUser: 'superadmin',
            user: 'Adm',
            access: response
        }
    }
    
    registerUser = (data) => {
        const urlSignup = this.urlLogin + 'signup';

        return this.http.post(urlSignup, JSON.stringify(data), httpOption);

    }

    getUser = () => {
       
        const httpOptions = this.settings.getHeadersJson();
        // return this.http.get(this.urlLogin + 'user', httpOptions)
        
          return  this.http.get(this.urlLogin + 'user', httpOptions)
  .pipe(
    tap(response => {
      // Hacer algo con la respuesta exitosa, si es necesario
      console.log('Respuesta exitosa:', response);
    }),
    catchError(error => {
      // Manejar el error y mostrarlo en la consola
      console.error('Error en la petición:', error);
      // Devolver un observable de error vacío para que la ejecución continúe
      this._router.navigate(['/pages/auth/lock']);

      return of(error);
    })
  )
    }

    logOut() {
        const httpOptions = this.settings.getHeadersJson();
        return this.http.get(this.urlLogin + 'logout', httpOptions)
    }

}